import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Admin from "../views/Admin.vue";
import Inicio from "../views/Inicio.vue";
import Usuarios from "../views/Usuarios.vue";
import Profissoes from "../views/Profissoes.vue";
import Cargos from "../views/Cargos.vue";
import Departamentos from "../views/Departamentos.vue";
import MotivosBloqueio from "../views/MotivosBloqueio.vue";
import Contatos from "../views/Contatos.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
    meta: {
      title: "Climb - Administração TES"
    }
  },
  {
    path: "/admin",
    component: Admin,
    children: [
      {
        name: "inicio",
        path: "inicio",
        alias: "/",
        component: Inicio,
        meta: {
          title: "Início"
        }
      },
      {
        name: "usuarios",
        path: "usuarios",
        component: Usuarios,
        meta: {
          title: "Usuários"
        }
      },
      {
        name: "profissoes",
        path: "profissoes",
        component: Profissoes,
        meta: {
          title: "Profissões"
        }
      },
      {
        name: "cargos",
        path: "cargos",
        component: Cargos,
        meta: {
          title: "Cargos"
        }
      },
      {
        name: "departamentos",
        path: "departamentos",
        component: Departamentos,
        meta: {
          title: "Departamentos"
        }
      },
      {
        name: "motivos_bloqueio",
        path: "motivos_bloqueio",
        component: MotivosBloqueio,
        meta: {
          title: "Motivos Bloqueio"
        }
      },
      {
        name: "contatos",
        path: "contatos",
        component: Contatos,
        meta: {
          title: "Contatos"
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
